import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
    data() {
        return {
            //发票详情弹框
            dialogTableVisible: false,
            //人名搜索发票
            nameSearch: "",
            // 身份证搜索
            idcardSearch: '',
            //订单号搜索发票
            orderNumSearch: "",
            // 开票金额搜索
            totalSearch: '',
            // 发票抬头搜索
            invoiceTitle: '',
            // 地址搜索
            invoiceAddressSearch: '',
            // 大于等于申请时间
            invoice_apply_date_egt: '',
            // 小于等于申请时间
            invoice_apply_date_elt: '',
            // 大于等于作废时间
            invoice_obsolete_date_egt: '',
            // 小于等于作废时间
            invoice_obsolete_date_elt: '',
            //发票的数据
            invoices: [],
            //发票的偏移量
            invoiceOffset: 0,
            //每页请求的数目
            invoiceLength: 15,
            //发票的总数量
            invoiceTotal: 0,
            //搜索的支付类型选择
            orderSearchType: [{
                value: "3",
                label: "批量开课"
            },
            {
                value: "5",
                label: "账号余额"
            },
            {
                value: "6",
                label: "郑州银行"
            }
            ],
            //搜索时候的类型
            typeSearch: "",
            //搜索的发票状态类型
            // 开票状态 0：未开票 1：开票中（已申请） 2：已审批 3：已发出（已开票）4：已回退 5：已作废 
            invoicesStatusType: [{
                value: "0",
                label: "未开票"
            },
            {
                value: "1",
                label: "已申请"
            },
            {
                value: "2",
                label: "已审批"
            },
            {
                value: "3",
                label: "已发出"
            },
            {
                value: "4",
                label: "已回退"
            },
            {
                value: "5",
                label: "已作废"
            },
            ],
            // 发票类型
            allInvoiceType: [{
                value: "0",
                label: "电子版"
            },
            {
                value: "1",
                label: "纸质版"
            }
            ],
            //搜索时的发票状态
            statusType: "",
            //搜索时的发票类型状态
            invoiceType: "",
            //点击某个订单时候的订单项
            order: {},
            //已经被选中的发票
            selectedInvoices: [],
            // 已经被选中的发票id
            selectedInvoiceIds: [],
            // 当前页
            currentPage: 1,
            searchStudent: {
                name: '',
                company: '',
                phone: '',
                idCard: '',
                sex: '',
                enabled: '',
                dateOfBrith: '',
            },
            // 发票对象
            invoiceObj: '',
            // 导出显示加载中
            exportLoading: false,
            // 导出excel
            excelDialog: false,
            exceldata: {
                offset: 0,
                length: 0
            },
        };
    },
    methods: {
		initpayDate(date){
			let initDate = ''
			if(date){
				 initDate = date.split(' ')[0]
			}
			return initDate
		},
        //计算一下状态
        countInvoiceStatus(state) {
            if (state == "0") {
                return "未开票";
            } else if (state == "1") {
                return "已申请";
            } else if (state == "2") {
                return "已审批";
            } else if (state == "3") {
                return "已发出";
            } else if (state == "4") {
                return "已回退";
            } else {
                return "已作废";
            }
        },
        //搜索发票
        confirmSearch() {
            this.currentPage = 1
            //判断支付类型和发票状态有没有选择，没有选择则为null则要进行置空
            String(this.typeSearch) == "null" ?
                (this.typeSearch = "") :
                this.typeSearch;
            String(this.statusType) == "null" ?
                (this.statusType = "") :
                this.statusType;
            String(this.invoiceType) == "null" ?
                (this.invoiceType = "") :
                this.invoiceType;

            //获取筛选的数据
            let data = {
                token: this.$store.state.authority_management,
                offset: this.invoiceOffset,
                length: this.invoiceLength,
                invoice_title_not_null: 1,
                invoice: '[2,3]',
                pay_type: 6
            };
            if (this.nameSearch) {
                data.user_name = this.nameSearch
            }
            if (this.idcardSearch) {
                data.idCard = this.idcardSearch
            }
            if (this.orderNumSearch) {
                data.code = this.orderNumSearch
            }
            if (this.statusType) {
                data.invoice_state = this.statusType
            }
            if (this.invoiceType) {
                data.invoice_type = this.invoiceType
            }
            if (this.totalSearch) {
                data.total = this.totalSearch
            }
            if (this.invoiceAddressSearch) {
                data.invoice_address = this.invoiceAddressSearch
            }
            if (this.invoice_apply_date_egt) {
                data.invoice_apply_date_egt = this.invoice_apply_date_egt
            }
            if (this.invoice_apply_date_elt) {
                data.invoice_apply_date_elt = this.invoice_apply_date_elt
            }
            if (this.invoice_obsolete_date_egt) {
                data.invoice_obsolete_date_egt = this.invoice_obsolete_date_egt
            }
            if (this.invoice_obsolete_date_elt) {
                data.invoice_obsolete_date_elt = this.invoice_obsolete_date_elt
            }
            //发送请求获取数据
            this.$post("orders/shop_search", data).then(res => {
                this.invoices = res.data.result.data;
                this.invoiceTotal = res.data.result.total;
                // console.log('voices',this.invoices)
            });
        },
        //已经被选中的行
        selectRow(val) {
            if (val.length !== 0) {
                this.selectedInvoices = val;
                this.selectedInvoiceIds = val.map(item => item.id);
                this.invoiceObj = val[0];
            }
        },
        //获取发票数据
        getInvoice() {
            //发给后端的数据
            let data = {
                token: this.$store.state.authority_management,
                offset: this.invoiceOffset,
                length: this.invoiceLength,
                invoice_title_not_null: 1,
                invoice: '[2,3]',
                pay_type: 6
            };
            if (this.nameSearch) {
                data.user_name = this.nameSearch
            }
            if (this.idcardSearch) {
                data.idCard = this.idcardSearch
            }
            if (this.orderNumSearch) {
                data.code = this.orderNumSearch
            }
            if (this.statusType) {
                data.invoice_state = this.statusType
            }
            if (this.invoiceType) {
                data.invoice_type = this.invoiceType
            }
            if (this.totalSearch) {
                data.total = this.totalSearch
            }
            if (this.invoiceAddressSearch) {
                data.invoice_address = this.invoiceAddressSearch
            }
            if (this.invoice_apply_date_egt) {
                data.invoice_apply_date_egt = this.invoice_apply_date_egt
            }
            if (this.invoice_apply_date_elt) {
                data.invoice_apply_date_elt = this.invoice_apply_date_elt
            }
            if (this.invoice_obsolete_date_egt) {
                data.invoice_obsolete_date_egt = this.invoice_obsolete_date_egt
            }
            if (this.invoice_obsolete_date_elt) {
                data.invoice_obsolete_date_elt = this.invoice_obsolete_date_elt
            }
            //发送请求获取数据
            this.$post("orders/shop_search", data).then(res => {
                this.invoices = res.data.result.data;
                this.invoiceTotal = res.data.result.total;
                // console.log('voices',this.invoices)
            });
        },
        //请求页面的数目发生变化
        handleSizeChange(val) {
            //根据val即页面数目值赋值
            this.invoiceLength = val;
            //再重新获取页面数据
            this.getInvoice();
        },
        //请求的页面发生变化
        handleCurrentChange(val) {
            this.currentPage = val;
            //根据val获取页数
            this.invoiceOffset = (val - 1) * this.invoiceLength;
            //重新获取数据
            this.getInvoice();
        },

        //查看详情
        handleDetail() {

            // console.log(obj)
            // this.order = obj;
            if (this.selectedInvoices.length == 0) {
                this.$message({
                    type: 'error',
                    message: '请选择一条数据'
                })
            } else if (this.selectedInvoices.length > 1) {
                this.$message({
                    type: 'error',
                    message: '只能选择一条数据'
                })
            } else if (this.invoiceObj.invoice_state == 5) {
                this.$message({
                    type: 'error',
                    message: '发票已作废！不能进行其它操作！'
                });
            } else {
                this.dialogTableVisible = true;
            }


        },
        //设置为已经开票状态
        alreadyOpenInvoice() {
            //循环已经选择的数组看看是否都是开票中状态的发票
            // for (let val of this.selectedInvoices) {
            //     // 如果有一个不是，则终止方法并提示
            //     if (val.invoice_state != "1") {
            //         this.$message({
            //             message: "设置为已开票状态的所选发票必须都是开票中状态的发票",
            //             type: "error"
            //         });
            //         return false;
            //     }
            // }

            if (this.selectedInvoices.length == 0) {
                this.$message({
                    message: "请至少选择一张发票",
                    type: "error"
                });
                return false;
            }

            //已经选择的发票过滤出只有id属性
            let ids = [];
            this.selectedInvoices.map(item => {
                ids.push(item.id);
            });
            //修改发票状态发给后台的的数据
            let data = {
                token: this.$store.state.authority_management,
                ids: JSON.stringify(ids),
                invoice_state: "2"
            };
            //发送请求修改发票状态
            this.$post("orders/edit", data).then(res => {
                if (res.data.status == "success") {
                    this.$message({
                        message: "已经成功设置为已开票状态",
                        type: "success"
                    });
                    //刷新数据
                    this.getInvoice();
                } else {
                    this.$message({
                        message: "设置失败",
                        type: "error"
                    });
                }
            });
        },

        // 导出excel
        exportExcel() {
            this.excelDialog = true;
        },

        // 确认导出
        confirmexport() {
            this.exportLoading = true;
            this.excelDialog = false;
            let data = {
                token: this.$store.state.authority_management,
                offset: this.exceldata.offset,
                length: this.exceldata.length,
                invoice_title_not_null: 1,
                invoice: '[2,3]',
                pay_type: 6
            }
            if (this.nameSearch) {
                data.user_name = this.nameSearch
            }
            if (this.idcardSearch) {
                data.idCard = this.idcardSearch
            }
            if (this.orderNumSearch) {
                data.code = this.orderNumSearch
            }
            if (this.statusType) {
                data.invoice_state = this.statusType
            }
            if (this.invoiceType) {
                data.invoice_type = this.invoiceType
            }
            if (this.totalSearch) {
                data.total = this.totalSearch
            }
            if (this.invoiceAddressSearch) {
                data.invoice_address = this.invoiceAddressSearch
            }
            if (this.invoice_apply_date_egt) {
                data.invoice_apply_date_egt = this.invoice_apply_date_egt
            }
            if (this.invoice_apply_date_elt) {
                data.invoice_apply_date_elt = this.invoice_apply_date_elt
            }
            if (this.invoice_obsolete_date_egt) {
                data.invoice_obsolete_date_egt = this.invoice_obsolete_date_egt
            }
            if (this.invoice_obsolete_date_elt) {
                data.invoice_obsolete_date_elt = this.invoice_obsolete_date_elt
            }

            this.$post('orders/orderInvoiceExport', data).then(res => {
                this.exportLoading = false;
                window.open(res.data.result)
            })
        },

        // 在输入框输入数据时触发
        inputNumber(e) {
            e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
        },

        // 保存修改发票
        saveEdit() {
            this.$post('orders/editInvoice', {
                token: this.$store.state.authority_management,
                id: this.invoiceObj.id,
                invoice_content: this.invoiceObj.invoice_content,
                invoice_email: this.invoiceObj.invoice_email,
                invoice_address: this.invoiceObj.invoice_address,
                invoice_open_bank: this.invoiceObj.invoice_open_bank,
                tax_no: this.invoiceObj.tax_no,
                invoice_note: this.invoiceObj.remark,
                invoice_title: this.invoiceObj.invoice_title
            }).then(res => {
                if (res.data.status === 'success') {
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败，请稍后重试');
                }
                this.dialogTableVisible = false;
                this.getInvoice();
            });
        },

        // 修改发票状态
        modifyInvoiceStatus(state) {
            if (this.selectedInvoiceIds.length <= 0) {
                this.$message.error('请最少选择一张发票');
                return;
            }
            if (this.invoiceObj.invoice_state == 5) {
                this.$message.error('发票已作废！不能进行其它操作！');
                return;
            }
            if (state == 5) {
                this.$confirm('您确定作废该发票吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 作废日期
                    let invoice_obsolete_date = this.getNetworkTime();
                    this.$post('orders/editInvoiceState', {
                        token: this.$store.state.authority_management,
                        ids: JSON.stringify(this.selectedInvoiceIds),
                        invoice_state: state,
                        invoice_obsolete_date: invoice_obsolete_date,
                    }).then(res => {
                        if (res.data.status === 'success') {
                            this.$message.success('修改发票状态成功');
                        } else {
                            this.$message.error(res.data.errorMsg);
                        }
                        this.getInvoice();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消作废发票'
                    });
                });
            } else {
                this.$post('orders/editInvoiceState', {
                    token: this.$store.state.authority_management,
                    ids: JSON.stringify(this.selectedInvoiceIds),
                    invoice_state: state,
                }).then(res => {
                    if (res.data.status === 'success') {
                        this.$message.success('修改发票状态成功');
                    } else {
                        this.$message.error(res.data.errorMsg);
                    }
                    this.getInvoice();
                });
            }
        },

        // 获取网络时间
        getNetworkTime() {
            let xmlhttp;
            if (window.XMLHttpRequest) {
                // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
                xmlhttp = new XMLHttpRequest();
            } else {
                // IE6, IE5 浏览器执行代码
                xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            }

            xmlhttp.open("GET", "https://quan.suning.com/getSysTime.do", false);
            xmlhttp.send();

            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                return JSON.parse(xmlhttp.responseText).sysTime2.substring(0, 10);
            } else {
                return '';
            }

        },
    },
    created() {
        //获取订单数据
        this.getInvoice();
    }
};
